export const INITIAL_MD_CONTENT =
  '' +
  '# Welcome to Bitdefender Markdown Editor\n' +
  'Type on the left, see it rendered on the right!\n \n' +
  '## Features\n \n' +
  '1. **Bold** and *italic* text\n' +
  '2. [Links](https://bitdefender.com)\n' +
  '3. Images\n' +
  '4. Lists';

// Maximum number of characters allowed in the editor
export const MAX_CHARS = 2000;

// Regular expression for Markdown link URL: [text](url)
export const LINK_REGEX = /^\[([^\]]+)\]\(([^)]+)\)$/;
// Regular expression for Markdown image URL, with file extension matches: ![alt text](url)
export const IMAGE_REGEX = /^!\[(.*?)\]\((.*?\.(?:jpg|jpeg|png|gif|bmp|svg|webp))\)$/i;
// Regular expression for plain URL (basic pattern for HTTP/HTTPS)
export const URL_REGEX = /^(https?:\/\/[^\s]+)$/;
// Regular expression for Markdown heading markers: #, ##, ###, ####, #####, ######
export const HEADING_REGEX = /^(#{1,6})\s*/;
